// extracted by mini-css-extract-plugin
module.exports = {"list":"AbTestVariantSelector_list__NWGVG","item":"AbTestVariantSelector_item___kIFW","text":"AbTestVariantSelector_text__bU5Jh","label":"AbTestVariantSelector_label__oeEk4"};